import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import $ from "jquery";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EnquiryDeleteReport = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

    // State for Follow-Up Modal
      const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);
      const [followUpDate, setFollowUpDate] = useState(moment().format("YYYY-MM-DD"));
      const [followUpReason, setFollowUpReason] = useState("");
    const [followUpOptions, setFollowUpOptions] = useState([]);


  useEffect(() => {
    fetchEnquiries();
  }, [startDate, endDate]);

  useEffect(() => {
    initializeDateRangePicker();
  }, []);

  
  const handleSaveFollowUp = async () => {
    if (!followUpDate || !followUpReason) {
      alert("Please fill in all fields");
      return;
    }
  
    try {
      const loggedInUser = localStorage.getItem("username"); // Get the logged-in username
  
      await axios.post(`${API_BASE_URL}/save_followup_two`, {
        userId: selectedUser?.user_id,
        followUpDate,
        followUpReason,
        createdBy: loggedInUser, // Send logged-in user
      });
  
      alert("Follow-up details saved successfully!");
      fetchEnquiries(); // Refresh the list
      closeFollowUpModal();
    } catch (error) {
      console.error("Error saving follow-up:", error);
      alert("Failed to save follow-up details.");
    }
  };

  

  const fetchEnquiries = async () => {
    setLoading(true);
    try {
  
      const response = await axios.post(`${API_BASE_URL}/enquiry_delete_enquiry_new`, {
        startDate,
        endDate,
      });
  
      const loggedInUser = localStorage.getItem("username"); // Retrieve logged-in username
  
      // Filter results based on allocatedUser
      const filteredEnquiries = response.data.filter(
        (enquiry) => enquiry.allocatedUser === loggedInUser
      );
  
      setEnquiries(filteredEnquiries); // Set only filtered data
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    } finally {
      setLoading(false);
    }
  };

  
  useEffect(() => {
      fetchFollowUpReasons();
    }, []);

    const fetchFollowUpReasons = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/followup-reasons`);
      setFollowUpOptions(response.data);
    } catch (error) {
      console.error("Error fetching follow-up reasons:", error);
    }
  };


  const handleReactivate = async (id) => {
    if (!window.confirm("Are you sure you want to reactivate this enquiry?")) {
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/reactivate_enquiry`, { id });

      alert("Enquiry reactivated successfully!");
      fetchEnquiries(); // Refresh the list after reactivation
      closeModal();
    } catch (error) {
      console.error("Error reactivating enquiry:", error);
      alert("Failed to reactivate enquiry.");
    }
  };

  const initializeDateRangePicker = () => {

    $("#enquiry_daterangepicker").daterangepicker(
      {
        startDate: moment(),
        endDate: moment(),
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
        },
      },

      (start, end) => {
        setStartDate(start.format("YYYY-MM-DD"));
        setEndDate(end.format("YYYY-MM-DD"));
        $("#enquiry_daterangepicker").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
      }
    );
    $("#enquiry_daterangepicker").html(`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`);
  };

 
  const openModal = (user) => {
    setSelectedUser(user);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedUser(null);
  };

  // Open Follow-Up Modal
  const openFollowUpModal = () => {
    setIsFollowUpModalOpen(true);
  };

  // Close Follow-Up Modal
  const closeFollowUpModal = () => {
    setIsFollowUpModalOpen(false);
    setFollowUpDate(moment().format("YYYY-MM-DD")); // Reset date
    setFollowUpReason(""); // Reset reason
  };


  const handleDelete = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this enquiry?")) {
      return;
    }
  
    try {
      await axios.post(`${API_BASE_URL}/delete_enquiry`, { userId });
  
      alert("Enquiry deleted successfully!");
      fetchEnquiries(); // Refresh the list after deletion
      closeModal();
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      alert("Failed to delete enquiry.");
    }
  };

  const handleMoveToSuccess = async (userId) => {
    if (!window.confirm("Are you sure you want to mark this enquiry as successful?")) {
      return;
    }
  
    try {
      await axios.post(`${API_BASE_URL}/move_to_success`, { userId });
  
      alert("Enquiry moved to success!");
      fetchEnquiries(); // Refresh the list after updating
      closeModal();
    } catch (error) {
      console.error("Error updating enquiry status:", error);
      alert("Failed to update enquiry.");
    }
  };
  

  // Handle Follow-Up Save
  // const handleSaveFollowUp = async () => {
  //   if (!followUpDate || !followUpReason) {
  //     alert("Please fill in all fields");
  //     return;
  //   }

  //   try {
  //     await axios.post(`${API_BASE_URL}/followup`, {
  //       userId: selectedUser?.id,
  //       followUpDate,
  //       followUpReason,
  //     });

  //     alert("Follow-up details saved successfully!");
  //     closeFollowUpModal();
  //   } catch (error) {
  //     console.error("Error saving follow-up:", error);
  //     alert("Failed to save follow-up details.");
  //   }
  // };

  const columns = [
    { name: "SlNo", selector: (row) => row.slNo, sortable: true, width: "90px" },
    {
        name: "Action",
        cell: (row) => (
            <button
                onClick={() => openModal(row)}
                className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
                View
            </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "150px",
    },
    { name: "Allocated User", selector: (row) => row.allocatedUser, sortable: true, width: "150px" },
    { name: "Name", selector: (row) => row.name, sortable: true, width: "150px" },
    { name: "Mobile No", selector: (row) => row.mobileno, sortable: true, width: "150px" },
    { name: "Type", selector: (row) => row.type, sortable: true, width: "150px" },
    { name: "Deleted Reason", selector: (row) => row.delete_reason, sortable: true },
    { name: "Deleted Date", selector: (row) => row.cdate, sortable: true, width: "190px" },

    // { name: "Enquiry Add Date", selector: (row) => row.addDate, sortable: true, width: "190px" },
    {
        name: "Follow-Up Status",
        selector: (row) => row.followup_status, // Display Follow-Up Status
        sortable: true,
        width: "180px",
        cell: (row) => (
            <span className={`px-2 py-1 rounded ${row.followup_status === "Follow-Up User" ? "bg-green-500 text-white" : "bg-gray-400 text-white"}`}>
                {row.followup_status}
            </span>
        ),
    },
];


  return (
    <div className="container mx-auto">
      <h2 className="text-2xl font-bold mt-9 text-center">Enquiry Deleted Report</h2>
      
      <div className="flex justify-center items-center mt-6 mb-6">
  <div id="enquiry_daterangepicker" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
    {`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
    
  </div>
</div>


      {loading ? <p>Loading...</p> : <DataTable columns={columns} data={enquiries} pagination />}

      {modalIsOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
            {selectedUser && (
              <>
                <h2 className="text-2xl font-bold text-center text-blue-600 underline mb-4">User Details</h2>
                <div className="space-y-2">
                  <p><b>Name:</b> {selectedUser.name}</p>
                  <p><b>Mobile No:</b> <span className="bg-green-500 text-white px-2 py-1 rounded-md">{selectedUser.mobileno}</span></p>
                  <p><b>Gender:</b> {selectedUser.gender}</p>
                  <p><b>Type:</b> {selectedUser.type}</p>
                  <p><b>District:</b> {selectedUser.district}</p>
                  <p><b>City:</b> {selectedUser.city}</p>
                </div>

                <div className="mt-8 flex justify-between gap-2">
                {/* <button
  className="bg-green-500 text-white px-4 py-2 rounded w-full"
  onClick={() => handleMoveToSuccess(selectedUser?.user_id)}
>
  Move to Success
</button>
<button
  className="bg-red-500 text-white px-4 py-2 rounded w-full"
  onClick={() => handleDelete(selectedUser?.user_id)}
>
  Delete
</button>
                    <button className="bg-orange-500 text-white px-4 py-2 rounded w-full" onClick={openFollowUpModal}>
                    Follow-up
                  </button>                */}

{selectedUser.followup_status === "Not a Follow-Up User" && (
                    <button
                      className="bg-yellow-400 text-white px-4 py-2 rounded w-full"
                      onClick={() => handleReactivate(selectedUser.id)}
                    >
                      Reactivate
                    </button>
                  )}
                     <button className="bg-gray-400 text-white px-4 py-2 rounded w-full" onClick={closeModal}>
                    Close
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

{isFollowUpModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4">
    <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-center text-blue-700 underline">Follow Up</h3>
      
      <div className="mb-4">
        <label htmlFor="followUpDate" className="block text-gray-700 font-medium mb-1">Follow Up Date:</label>
        <input
          id="followUpDate"
          type="date"
          value={followUpDate}
          onChange={(e) => setFollowUpDate(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

         {/* Dropdown for Follow-Up Reason */}
         <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-1">Follow Up Reason:</label>
              <select
    value={followUpReason}
    onChange={(e) => setFollowUpReason(e.target.value)}
    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
>
    <option value="">Choose Any One</option>
    {followUpOptions.map((option) => (
        <option key={option.id} value={option.id}>
            {option.name}  {/* This displays the name, but we send the ID */}
        </option>
    ))}
</select>

            </div>

      <div className="flex justify-between mt-4">
        <button
          onClick={handleSaveFollowUp}
          className="w-full bg-green-500 text-white font-medium py-2 rounded-md hover:bg-green-600 transition"
        >
          Save
        </button>
        <button
          onClick={closeFollowUpModal}
          className="w-full bg-red-500 text-white font-medium py-2 rounded-md hover:bg-red-600 transition ml-2"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default EnquiryDeleteReport;
